import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SearchService } from '../../Service/search';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-header',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './header.html',
  styleUrls: ['./header.css']
})
export class Header implements OnInit {

  @Output() toggleSidebar = new EventEmitter<void>();
  searchText: string = '';
  pageTitle: string = 'Bank Detail';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private searchService: SearchService
  ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    ).subscribe(data => {
      this.pageTitle = data['title'] || 'Dashboard';
    });
  }

  onSearchChange(text: string) {
    this.searchService.updateSearch(text);
  }

  triggerBankModal() {
    window.dispatchEvent(new Event('openBankModal'));
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}